import {request, submitFile} from "@/backend/backend_util.ts";
import {CheckinData, Team} from "@/types/DataTypes.ts";

export type UserProfileType = {
    id: number,
    username: string,
    email: string,
    meta: {[key: string]: any},
    pulse_enabled: boolean,
    name: string,
    title: string,
    department: any,
    github: string,
    team?: string, // Legacy team field
    teamId?: number, // New team ID
    teamObj?: Team // New team object
    managerId?: number, // Direct manager
    people?: BaseUserData[],
    leaders?: BaseUserData[]
}

type BaseUserData = {
    id: number,
    name: string,
    username: string,
    title: string
}
export type ProfileRelationType = {
    leader: boolean,
    reviewer: boolean
}

export type ProfileResponseType = {
    user: UserProfileType,
    relations: ProfileRelationType
}

export const profileBackend = {
    getself: request<UserProfileType>('GET', '/profile'),
    get: (username: string) => request<ProfileResponseType>('GET', '/profile/' + username)(),
    getCheckins: (userId: number, weekOf: string) => request<CheckinData[]>('GET', `/profile/${userId}/checkins/${weekOf}`)(),
    update: request<ProfileResponseType>('PUT', '/profile'),
    uploadAvatar: (userId: number, file: File) => submitFile('POST', `/profile/${userId}/avatar`, file),
    
    // Organizational relationships
    addDirectReports: (userId: number, userIds: number[]) => 
        request<ProfileResponseType>('POST', `/profile/${userId}/direct-reports`)({userIds}),
    removeDirectReports: (userId: number, userIds: number[]) => 
        request<ProfileResponseType>('DELETE', `/profile/${userId}/direct-reports`)({userIds}),
    addLeaders: (userId: number, userIds: number[]) => 
        request<ProfileResponseType>('POST', `/profile/${userId}/leaders`)({userIds}),
    removeLeaders: (userId: number, userIds: number[]) => 
        request<ProfileResponseType>('DELETE', `/profile/${userId}/leaders`)({userIds}),
    setDirectManager: (userId: number, managerId: number | null) => 
        request<ProfileResponseType>('POST', `/profile/${userId}/manager`)({managerId}),
}
